"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BrightSignMetricsProvider", {
  enumerable: true,
  get: function () {
    return _BrightSignMetricsProvider.default;
  }
});
Object.defineProperty(exports, "DeviceManufacturer", {
  enumerable: true,
  get: function () {
    return _DeviceType.DeviceManufacturer;
  }
});
Object.defineProperty(exports, "DeviceMetricsProvider", {
  enumerable: true,
  get: function () {
    return _provider.default;
  }
});
Object.defineProperty(exports, "DeviceMetricsProviderFactory", {
  enumerable: true,
  get: function () {
    return _factory.default;
  }
});
Object.defineProperty(exports, "DeviceType", {
  enumerable: true,
  get: function () {
    return _DeviceType.default;
  }
});
Object.defineProperty(exports, "XumoMetricsProvider", {
  enumerable: true,
  get: function () {
    return _XumoMetricsProvider.default;
  }
});
Object.defineProperty(exports, "collectDeviceMetrics", {
  enumerable: true,
  get: function () {
    return _collect.collectDeviceMetrics;
  }
});
var _provider = _interopRequireDefault(require("./provider"));
var _factory = _interopRequireDefault(require("./factory"));
var _BrightSignMetricsProvider = _interopRequireDefault(require("./providers/brightsign/BrightSignMetricsProvider"));
var _XumoMetricsProvider = _interopRequireDefault(require("./providers/xumo/XumoMetricsProvider"));
var _DeviceType = _interopRequireWildcard(require("./DeviceType"));
var _collect = require("./collect");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }